import { FtueVideo, FtueVideoThumbnail } from '../../../../api/core'
import { EditableFtueChapter } from '../../../components/FtueChapterEditor/ftueChapterHelpers'

export const ONBOARDING_VIDEO_TYPE = 'onboarding'

export type OnboardingVideoCreateBody = {
  vimeoId: string
  chapters: []
  thumbnails: FtueVideoThumbnail[]
  type: typeof ONBOARDING_VIDEO_TYPE
  names: { en: string }
}

export type OnboardingVideoUpdateBody = Omit<FtueVideo, 'chapters'> & { chapters: EditableFtueChapter[] }

export type OnboardingVideoFormValues = {
  names: { [lang: string]: string }
  videoName: string
  thumbnails: FtueVideoThumbnail[]
  chapters: EditableFtueChapter[]
}
